"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpProducer = void 0;
var tslib_1 = require("tslib");
var Endpoints = require("../config/endpoints");
var convert_case_1 = require("../helpers/convert-case");
var uuid_1 = require("../helpers/uuid");
/* eslint-disable @typescript-eslint/naming-convention, @typescript-eslint/ban-ts-comment */
var producer_errors_1 = require("./producer-errors");
var HttpProducer = /** @class */ (function () {
    function HttpProducer(edgeDomain, keepalive) {
        if (edgeDomain === void 0) { edgeDomain = Endpoints.DEVELOPMENT_DOMAIN; }
        if (keepalive === void 0) { keepalive = false; }
        this.edgeDomain = edgeDomain;
        this.keepalive = keepalive;
    }
    HttpProducer.withEndpoint = function (edgeEndpoint) {
        return new HttpProducer(Endpoints.extractDomain(edgeEndpoint));
    };
    HttpProducer.getHeadersFromMetadata = function (metadata) {
        var headers = {
            'Content-Type': 'application/json; charset=utf-8',
            'X-Monorail-Edge-Event-Created-At-Ms': ((metadata && metadata.eventCreatedAtMs) ||
                Date.now()).toString(),
            'X-Monorail-Edge-Event-Sent-At-Ms': Date.now().toString(),
            'X-Monorail-Edge-Client-Message-Id': ((metadata && metadata.clientMessageId) ||
                (0, uuid_1.v4)()).toString(),
        };
        if (metadata && metadata.userAgent) {
            headers['User-Agent'] = metadata.userAgent;
        }
        if (metadata && metadata.remoteIp) {
            headers['X-Forwarded-For'] = metadata.remoteIp;
        }
        return headers;
    };
    HttpProducer.prototype.produceBatch = function (monorailEvent) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var body, edgeResponse, error_1, response, _a;
            var _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        body = {
                            events: (0, convert_case_1.convertAllEventsToUnderscoreCase)(monorailEvent),
                            metadata: (0, convert_case_1.toUnderscoreCase)(monorailEvent.metadata),
                        };
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetch(this.produceBatchEndpoint(), {
                                method: 'post',
                                headers: HttpProducer.getHeadersFromMetadata(monorailEvent.metadata),
                                body: JSON.stringify(body),
                                keepalive: this.keepalive,
                            })];
                    case 2:
                        edgeResponse = _c.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _c.sent();
                        // @ts-ignore
                        throw new producer_errors_1.MonorailRequestError(error_1);
                    case 4:
                        if (!(edgeResponse.status === 207)) return [3 /*break*/, 6];
                        return [4 /*yield*/, edgeResponse.json()];
                    case 5:
                        response = (_c.sent());
                        throw new producer_errors_1.MonorailBatchProduceError(response);
                    case 6:
                        if (!!edgeResponse.ok) return [3 /*break*/, 8];
                        _a = producer_errors_1.MonorailUnableToProduceError.bind;
                        _b = {
                            status: edgeResponse.status
                        };
                        return [4 /*yield*/, edgeResponse.text()];
                    case 7: throw new (_a.apply(producer_errors_1.MonorailUnableToProduceError, [void 0, (_b.message = _c.sent(),
                            _b)]))();
                    case 8: return [2 /*return*/, { status: edgeResponse.status }];
                }
            });
        });
    };
    HttpProducer.prototype.produce = function (monorailEvent) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var convertToUnderscoreCase, body, edgeResponse, error_2, _a;
            var _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        convertToUnderscoreCase = true;
                        if (monorailEvent &&
                            monorailEvent.options &&
                            Object.prototype.hasOwnProperty.call(monorailEvent.options, 'convertEventCase')) {
                            convertToUnderscoreCase = Boolean(monorailEvent.options.convertEventCase);
                        }
                        body = {
                            schema_id: monorailEvent.schemaId,
                            payload: (0, convert_case_1.toUnderscoreCase)(monorailEvent.payload, convertToUnderscoreCase),
                        };
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetch(this.produceEndpoint(), {
                                method: 'post',
                                headers: HttpProducer.getHeadersFromMetadata(monorailEvent.metadata),
                                body: JSON.stringify(body),
                                keepalive: this.keepalive,
                            })];
                    case 2:
                        edgeResponse = _c.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _c.sent();
                        // @ts-ignore
                        throw new producer_errors_1.MonorailRequestError(error_2);
                    case 4:
                        if (!edgeResponse) {
                            throw new producer_errors_1.MonorailUnableToProduceError({
                                message: 'No response from edge',
                            });
                        }
                        if (!!edgeResponse.ok) return [3 /*break*/, 6];
                        _a = producer_errors_1.MonorailUnableToProduceError.bind;
                        _b = {
                            status: edgeResponse.status
                        };
                        return [4 /*yield*/, edgeResponse.text()];
                    case 5: throw new (_a.apply(producer_errors_1.MonorailUnableToProduceError, [void 0, (_b.message = _c.sent(),
                            _b)]))();
                    case 6: return [2 /*return*/, { status: edgeResponse.status }];
                }
            });
        });
    };
    HttpProducer.prototype.produceBatchEndpoint = function () {
        return this.edgeDomain + Endpoints.PRODUCE_BATCH_ENDPOINT;
    };
    HttpProducer.prototype.produceEndpoint = function () {
        return this.edgeDomain + Endpoints.PRODUCE_ENDPOINT;
    };
    return HttpProducer;
}());
exports.HttpProducer = HttpProducer;
/* eslint-enable @typescript-eslint/naming-convention, @typescript-eslint/ban-ts-comment */
